export class RenewBenefitsMass {
  public ProfileIds: number[];
  public SelectAll: boolean;

  public constructor() {
    this.ProfileIds = new Array<number>();
    this.SelectAll = false;
  }
}
